import type { SVGProps } from 'react';
const SvgTextRotateUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#text_rotate_up_svg__a)">
      <path
        fill="currentColor"
        d="M3 12v1.5l11 4.75v-2.1l-2.2-.9v-5l2.2-.9v-2.1L3 12Zm7 2.62-5.02-1.87L10 10.88v3.74Zm8-10.37-3 3h2v12.5h2V7.25h2l-3-3Z"
      />
    </g>
    <defs>
      <clipPath id="text_rotate_up_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgTextRotateUp;
